import * as types from "./mutation-type";
import { getBenefitsQuery, getStoreBenefitsQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {

  //fetch company/store benefits
  async getBenefits({ commit }, variables = {}) {
    try {
      commit(types.GET_BENEFITS_BEGIN);
      const {
        data: {
          data
        }
      } = await gqlClient.query({

        query     : variables.isStore ? getStoreBenefitsQuery : getBenefitsQuery,
        variables : variables
      });
      
      commit(types.GET_BENEFITS_SUCCESS, variables.isStore ? data.store.benefits : data.company.benefits);
    } catch (e) {
      commit(types.GET_BENEFITS_ERROR, e);
    }
  },
  
  //delete benefit
  async deleteBenefit({ commit }, id) {
    try {
      commit(types.DELETE_BENEFIT_BEGIN);
      await api.benefit.deleteBenefit(id);
      commit(types.DELETE_BENEFIT_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_BENEFIT_ERROR, e);
    }
  },

  //create new benefit
  async createBenefit({ commit }, variables ) { 
    try {
      commit(types.CREATE_BENEFIT_BEGIN)
      const { data } = await api.benefit.addBenefit(variables)
      commit(types.CREATE_BENEFIT_SUCCESS, data)
    } catch (e) {
      commit(types.CREATE_BENEFIT_ERROR, e)
    }
  },

  //update benefit by its id
  async updateBenefit({ commit }, { id, data }){
    commit(types.UPDATE_BENEFIT_BEGIN)
    try {
      const { data : updatedData } = await api.benefit.update(id,data)
      commit(types.UPDATE_BENEFIT_SUCCESS, updatedData)
    } catch (error) {
      commit(types.UPDATE_BENEFIT_ERROR, error)
    }
  },

  //create benefit in user_emp section
  async createUserBenefit({ commit, rootState }, userData) { 
    try {
      commit(types.ADD_USER_BENEFIT_BEGIN, userData.userId)
      const { data }  = await api.userBenefit.addUserBenefit(userData)
      commit(types.ADD_USER_BENEFIT_SUCCESS, { data, rootState })
    } catch (e) {
      commit(types.ADD_USER_BENEFIT_ERROR, { e, userId : userData.userId })
    }
  },
  
  //delete benefit in user_emp section
  async deleteUserBenefit({ commit, rootState }, { id, userId }) {
    try {
      commit(types.DELETE_USER_BENEFIT_BEGIN, userId);
      await api.userBenefit.delUserBenefit(id);
      commit(types.DELETE_USER_BENEFIT_SUCCESS, { userId, rootState });
    } catch (err) {
      commit(types.DELETE_USER_BENEFIT_ERROR, { err, userId });
    }
  }
};
export default actions;
